import { Component, OnInit, Input, EventEmitter } from '@angular/core'
import { ActionComponent, Module, Payload } from '@bp/core'
import { FormGroup, Validators, FormBuilder } from '@angular/forms'
import { SharedHttpService } from '~/shared/http/shared-http.service'
import { Router } from '@angular/router'
import { NzMessageService } from 'ng-zorro-antd'

@Component({
  selector: 'app-template-refresh-free',
  templateUrl: './template-refresh-free.component.html',
  styleUrls: ['./template-refresh-free.component.styl'],
})
export class TemplateRefreshFreeComponent extends ActionComponent implements OnInit {
  static meta = {
    type: 'custom_action',
    name: 'template-refresh-free',
  }

  validateForm = this._fb.group({
    free: [null, Validators.required],
  })

  dispatch = new EventEmitter<Payload>()

  formStyle = {
    offset: 5,
    span: 15,
  }

  fields = [
    {
      name: '免费类型',
      identifier: 'free',
      type: 'select',
      extra: {
        "0": '收费',
        "1": '限时免费',
        "2": '首次免费',
      },
      place: [],
      feature: [],
      form: {
        type: 'select',
      },
    },
  ]

  @Input() entity: any
  @Input() module: Module

  showModal = false

  bpOnClick = () => {
    this.openModal()
  }

  constructor(
    private _fb: FormBuilder,
    private _router: Router,
    private _sharedHttp: SharedHttpService,
    private _msgService: NzMessageService,
  ) {
    super()
  }

  ngOnInit() {}

  openModal() {
    this.showModal = true
    this.validateForm.reset()

  }

  closeModal() {
    this.showModal = false
  }

  handleOk() {
    if (this.entity) {
      this._sharedHttp.templateBatch(
        this.entity.id,
        'refresh',
        { free: this.validateForm.get('free').value }
      ).subscribe(res => {
        this._msgService.success('操作成功')
        this.dispatch.emit({ type: 'refresh' })
      })
    } else {
      this.dispatch.emit({
        type: 'batch',
        batchType: 'refresh',
        data: { free: this.validateForm.get('free').value },
      })
    }

    this.showModal = false
  }
}
